import React from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { CustomSelect, Modal } from 'src/components';
import useFetch from 'src/hooks/useFetch';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import TextField from 'src/components/text-field';
import Button from 'src/components/button';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchFloor } from 'src/redux/action/floor.action';
import { fetchTable } from 'src/redux/action/table.action';
import DiscountCustomSelect from 'src/components/DiscountSelect/DiscountCustomSelect';
import SlideInModal from 'src/components/slideInModal';

interface IProps {
  handleModal: () => void;
  showModal: boolean;
  setIsEdit: (val: boolean) => void;
  setEditId: (val: string) => void;
  isEdit: boolean;
  editId: string;
  editTableData: any;
}

type floorsPostValue = {
  name: string;
  occupancy: any;
  floorId: string;
};

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string().required('Table Name is required'),
  floorId: Yup.string().required('Floor Name is required'),
  occupancy: Yup.number()
    .typeError('Occupancy must be in number')
    .required('Occupancy is required'),
});

const AddTable: React.FC<IProps> = ({
  showModal,
  handleModal,
  editId,
  isEdit,
  setEditId,
  setIsEdit,
  editTableData,
}) => {
  const [errorMsgPost, setErrorMsgPost] = React.useState('');
  const dispatch = useDispatch();
  const { floorData } = useSelector(({ floorData }: RootState) => floorData);
  React.useEffect(() => {
    if (floorData.length > 0) return;
    dispatch(fetchFloor() as any);
  }, [dispatch]);

  const intValues = {
    id: editTableData.id ?? '',
    name: editTableData.name ?? '',
    occupancy: editTableData.occupancy ?? null,
    floorId: editTableData ? editTableData.floor?.id : '',
  };
  const handleSubmit = async (val: floorsPostValue) => {
    const editPayload = {
      // id: "",
      ...val,
    };
    try {
      if (editId) {
        await Service.put('/floors/tables/edit', val);
      } else {
        await Service.post('/floors/tables/create', val);
      }
      handleModal();
      toastAlert(
        'success',
        `${val?.name} is successfully ${editId ? 'edited' : 'added'}`
      );
      dispatch(fetchTable() as any);
      setIsEdit(false);
      setEditId('');
      setErrorMsgPost('');
    } catch (err: any) {
      setErrorMsgPost(err?.response?.data?.message);
      setIsEdit(false);
      setEditId('');
    }
  };

  return (
    <>
      {showModal && (
        <SlideInModal
          showModal={showModal}
          title={isEdit ? 'Edit Table' : 'Add Table'}
          onClick={handleModal}
          className="bg-pure-white z-[9999]"
        >
          <div className="mx-5 mt-4">
            {errorMsgPost && (
              <p className="text-warning text-center text-sm font-semibold capitalize">
                {errorMsgPost}
              </p>
            )}
            <Formik
              initialValues={intValues}
              validateOnMount
              validationSchema={FORM_VALIDATION}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ isSubmitting, isValid, values }) => (
                <Form className="mt-5">
                  <TextField
                    label="Table Name"
                    name="name"
                    defaultValue={
                      isEdit && editTableData ? editTableData?.name : ''
                    }
                  />
                  <TextField
                    label="Pax"
                    name="occupancy"
                    type="text"
                    defaultValue={
                      isEdit && editTableData ? editTableData?.occupancy : ''
                    }
                  />
                  <Field
                    name="floorId"
                    className="mt-3"
                    options={floorData ?? []}
                    component={CustomSelect}
                    defaultValue={
                      isEdit && editTableData ? editTableData?.floor?.name : ''
                    }
                    isMulti={false}
                    label="Assign to Area"
                    placeholder={'select an area'}
                  />
                  <div className="flex items-center justify-end mt-10">
                    <Button
                      text={isEdit ? 'edit table' : 'add table'}
                      variant="primary"
                      isSubmitting={isSubmitting}
                      isValid={isValid}
                      type="submit"
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </SlideInModal>
      )}
    </>
  );
};

export default React.memo(AddTable);
